// function updateActiveState() {
//   const activeTypeBtn = document.querySelector('.flexible_variable .type-btn.active');
//   const activeDateBtn = document.querySelector('.dates-container .choose-dates.desktop_program_select.active .date-btn.active');
//   const dateSelect = document.getElementById('date-options');

//   if (!activeTypeBtn || !activeDateBtn || !dateSelect) return;

//   const activeDate = activeDateBtn.dataset.date;
//   const activeType = activeTypeBtn.dataset.type.toLowerCase();

//   const matchingOption = Array.from(dateSelect.options).find(opt => opt.dataset.date === activeDate);
//   if (!matchingOption) return;

//   if (dateSelect.value !== matchingOption.value) {
//     dateSelect.value = matchingOption.value;
//     dateSelect.dispatchEvent(new Event('change', { bubbles: true }));
//   }

//   const optionTitle = matchingOption.dataset.varTitle;
//   const buttonLabel = document.querySelector(
//     `variant-selects[data-id="variant-selects-id"] .product-form__input label[data-title="${optionTitle}"]`
//   );

//   if (buttonLabel && !buttonLabel.classList.contains('checked-programmatically')) {
//     buttonLabel.classList.add('checked-programmatically');
//     buttonLabel.click();
//     setTimeout(() => buttonLabel.classList.remove('checked-programmatically'), 100);
//   }
//   setTimeout(function() {
//     initDepoListeners();
//   }, 2000);
// }

// function handleTypeChange(btn) {
//   document.querySelectorAll('.type-btn').forEach(b => b.classList.remove('active'));
//   btn.classList.add('active');

//   const type = btn.dataset.type.toLowerCase();
//   document.querySelectorAll('.choose-dates').forEach(container => {
//     const isMatch = container.dataset.type.toLowerCase() === type;
//     container.classList.toggle('active', isMatch);

//     if (isMatch) {
//       const dateBtns = container.querySelectorAll('.date-btn');
//       dateBtns.forEach(b => b.classList.remove('active'));
//       if (dateBtns.length > 0) dateBtns[0].classList.add('active');
//     }
//   });

//   updateActiveState();
// }

// function handleDateChange(btn) {
//   btn.closest('.dates-buttons').querySelectorAll('.date-btn').forEach(b => b.classList.remove('active'));
//   btn.classList.add('active');
//   updateActiveState();
// }

// function initializeListeners() {
//   document.querySelectorAll('.flexible_variable .type-btn').forEach(btn => {
//     btn.addEventListener('click', () => handleTypeChange(btn));
//   });

//   document.querySelectorAll('.dates-buttons .date-btn').forEach(btn => {
//     btn.addEventListener('click', () => handleDateChange(btn));
//   });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   initializeListeners();
//   updateActiveState();
// });

// function initCustomSelects() {
//   if (window.innerWidth < 750) {
//     document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
//       if (wrapper.dataset.initialized === "true") return;
//       wrapper.dataset.initialized = "true";

//       const trigger = wrapper.querySelector('.custom-select-trigger');
//       const options = wrapper.querySelector('.custom-options');
//       const radios = options.querySelectorAll('.custom-radio-option input[type=radio]');
//       const displaySpan = trigger.querySelector('span');

//       trigger.addEventListener('click', () => {
//         options.classList.toggle('options_show');
//       });
//       document.addEventListener('click', e => {
//         if (!wrapper.contains(e.target)) {
//           options.classList.remove('options_show');
//         }
//       });
//       radios.forEach(radio => {
//         radio.addEventListener('change', () => {
//           if (radio.checked) {
//             displaySpan.textContent = radio.value;
//             options.classList.remove('options_show');
//           }
//         });
//       });
//     });
//   }
// }

// document.addEventListener('DOMContentLoaded', initCustomSelects);

// window.addEventListener('resize', function() {
//   initCustomSelects();
// });


document.addEventListener('DOMContentLoaded', function() {
  // const mobileDates = document.querySelectorAll('.mobile_program_select .date-btn');
  // const desktopDates = document.querySelectorAll('.desktop_program_select .date-btn');

  // function activateDesktopDate(selectedDate) {
  //   desktopDates.forEach(btn => {
  //     if (btn.dataset.date === selectedDate) {
  //       btn.classList.add('active');
  //       btn.click();
  //     } else {
  //       btn.classList.remove('active');
  //     }
  //   });
  // }

  // mobileDates.forEach(mobBtn => {
  //   mobBtn.addEventListener('click', function () {
  //     const selectedDate = this.dataset.date;
  //     mobileDates.forEach(b => b.classList.remove('active'));
  //     this.classList.add('active');
  //     activateDesktopDate(selectedDate);

  //     const trigger = document.querySelector('.custom-select-trigger span');
  //     if (trigger) trigger.textContent = selectedDate;
  //   });
  // });

  async function checkCC(params) {
    const regionId = document.querySelector('#product_region_id');
    if (regionId) {
        const regionIdValue = regionId.getAttribute('region-id');
        if (regionIdValue === 'United Kingdom' || regionIdValue === 'Estonia') {
          let countryCode = document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).dataset.value;
          let cart = await fetch('/cart.js').then(r => r.json());
          let conCode = null;
          if(cart.item_count>0){
            for(item of cart.items){
              conCode = item.properties['_region'];
            }
          }
          if(countryCode != Shopify.country){
            if(conCode==null){
              document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).click();
            }else{
              if(conCode !== regionIdValue){
                document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).click();
              }else{
                document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).click();
              }
            }
          }
        }
    }
  }
  checkCC();
  
  const sections = document.querySelectorAll('.image_optimization[data-src-desktop]');
  const loadBackground = (section) => {
    const isMobile = window.innerWidth <= 768;
    const bgImage = isMobile
      ? section.getAttribute('data-src-mobile')
      : section.getAttribute('data-src-desktop');

    if (bgImage) {
      section.style.backgroundImage = `url(${bgImage})`;
      section.dataset.current = isMobile ? 'mobile' : 'desktop';
    }
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadBackground(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: "0px 0px",
    threshold: 0.2 
  });

  sections.forEach(section => observer.observe(section));
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      sections.forEach(section => {
        const current = section.dataset.current;
        const isMobile = window.innerWidth <= 768;
        const shouldBe = isMobile ? 'mobile' : 'desktop';
        if (current && current !== shouldBe) {
          loadBackground(section);
        }
      });
    }, 250);
  });

  const desktopImages = document.querySelectorAll('.image_optimization_block img[data-src-desktop]');
  const mobileImages = document.querySelectorAll('.image_optimization_block img[data-src-mobile]');

  function handleImageVisibility() {
    const isMobile = window.innerWidth <= 768;

    desktopImages.forEach(img => {
      img.style.display = isMobile ? 'none' : 'block';
      if (!isMobile && !img.src) img.src = img.dataset.srcDesktop;
    });

    mobileImages.forEach(img => {
      img.style.display = isMobile ? 'block' : 'none';
      if (isMobile && !img.src) img.src = img.dataset.srcMobile;
    });
  }

  const observers = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        handleImageVisibility();
        observers.unobserve(entry.target);
      }
    });
  }, 
  { 
    rootMargin: "0px 0px",
    threshold: 0.2 
  }
 );

  document.querySelectorAll('.image_optimization_block').forEach(block => observers.observe(block));

  window.addEventListener('resize', () => {
    clearTimeout(window.resizing);
    window.resizing = setTimeout(handleImageVisibility, 250);
  });


  const card_product_section = document.querySelectorAll(".card_product_section");
  const loadImages = (section) => {
  const images = section.querySelectorAll(
      ".card_product_image_optimization img[data-src], .card_product_image_optimization img[data-srcset]"
    );
    images.forEach((img) => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute("data-src");
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute("data-srcset");
      }
    });
  };
  const observerss = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImages(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px 0px",
      threshold: 0.2
    }
  );
  card_product_section.forEach((section) => observerss.observe(section));

  // const imageWrappers = document.querySelectorAll('.image_optimization_load');
  //   if(imageWrappers.length > 0){
  //   imageWrappers.forEach(function(wrapper){
  //       const dataSrc = wrapper.getAttribute("data-src");
  //       const img = wrapper.querySelector("img");
  //       img.src = dataSrc;
  //   });
  // }
  
 function initTaxToggle() {
    const taxCheckboxes = document.querySelectorAll(
      '.cart-drawer__footer .cart_tax_block input[type="checkbox"], .cart__footer .cart__blocks .cart_tax_block input[type="checkbox"]'
    );
    const taxWidgets = document.querySelectorAll(
      '.drawer__footer #show_tax_number, .cart__footer .cart__blocks #show_tax_number'
    );
    if (!taxCheckboxes.length || !taxWidgets.length) return;
    function toggleTaxWidget(checkbox) {
      taxWidgets.forEach(widget => {
        checkbox.checked
          ? widget.classList.add("tax-active")
          : widget.classList.remove("tax-active");
      });
    }
    taxCheckboxes.forEach(checkbox => {
      toggleTaxWidget(checkbox);
      checkbox.addEventListener("change", () => toggleTaxWidget(checkbox));
    });
  }
  document.addEventListener("DOMContentLoaded", initTaxToggle);
  document.addEventListener("cart:updated", initTaxToggle);
  document.addEventListener("cart-drawer:open", initTaxToggle);
  document.addEventListener("cart-drawer:opened", initTaxToggle);

  const drawerObserver = new MutationObserver(initTaxToggle);
  drawerObserver.observe(document.body, { childList: true, subtree: true });

  document.querySelector('.proceed_to_cart #proceed-to-cart').addEventListener('click', () => {
    cartData();
  });

  async function cartData() {
    let cart = await fetch('/cart.js').then(r => r.json());
    let conCode = null;
      for(item of cart.items){
        conCode = item.properties['_region'];
      }
      window.location.href = "/cart";
  }
  
  const showMoreBtn = document.getElementById("show-more");
  if (showMoreBtn) {
    showMoreBtn.addEventListener("click", function () {
      document.querySelectorAll(".hidden-mobile").forEach(function (item) {
        item.classList.remove("hidden-mobile");
      });
      this.style.display = "none";
    });
  }



const checkoutButtons = document.querySelectorAll('.custom_cart__checkout-button');
  checkoutButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      const agreeCheckbox = document.querySelector('.custom_cart__footer  .cart-tos-checkbox');
      if (agreeCheckbox.checked) {
        e.target.form.submit();
      } else {
        alert("You must agree with the terms and conditions of sales to check out.");
        e.preventDefault();
      }
    });
  });
});


// function initDepoListeners() {
//     const targetInput = document.querySelector('.line-item-property__fieldsss input#lineItem');
//     if (!targetInput) return;
    
//     document.querySelectorAll('.depo-group-border-bottom input').forEach(function (item) {
//         // Skip if already initialized
//         if (item.dataset.depoInit === 'true') return;
//         item.dataset.depoInit = 'true';
        
//         item.addEventListener('change', function () {
//             console.log('Holosomatic');
//             const dataName = this.getAttribute('data-name');
//             if (dataName === 'Deposit') {
//                 targetInput.value = 'The final payment will be charged 30 days before the training starts.';
//             } else {
//                 targetInput.value = '';
//             }
//             console.log(targetInput.value);
//         });
//     });
// }

// document.addEventListener('DOMContentLoaded', function () {
//     setTimeout(function () {
//         initDepoListeners();
//     }, 2000);
// });



// window.addEventListener('load', function () {
//   const mediaWrappers = document.querySelectorAll('.image_optimization_load');
//   if (!mediaWrappers.length) return;
//   mediaWrappers.forEach(function (wrapper) {
//       const dataSrc = wrapper.getAttribute('data-src');
//       const dataSrcSet = wrapper.getAttribute('data-srcset');
//       if (wrapper.tagName.toLowerCase() === 'img') {
//         wrapper.src = dataSrc;
//         wrapper.srcset = dataSrcSet;
//         return;
//       }
//   });
// });


// function initDepoListeners() {
//     const targetInput = document.querySelector('.line-item-property__fieldsss input#lineItem');
//     if (!targetInput) return;
//     document.querySelectorAll('.depo-group-border-bottom input').forEach(function (item) {
//         const noteEl = document.querySelector('body .custom-text-class');
//         const datatext = noteEl ? noteEl.getAttribute('data-note') : '';
//         if (item.dataset.depoInit === 'true') return;
//         item.dataset.depoInit = 'true';
//         item.addEventListener('change', function () {
//             console.log('Holosomatic');
//             const dataName = this.getAttribute('data-name');
//             if (dataName === 'Deposit') {
//                 targetInput.value = datatext;
//             } else {
//                 targetInput.value = '';
//             }
//             console.log(targetInput.value);
//         });
//     });
// }

// document.addEventListener('DOMContentLoaded', function () {
//     setTimeout(function () {
//         initDepoListeners();
//     }, 2000);
// });